// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.agent_feild {
  width: 100%;
  float: left;
}

.guidtype_feild {
  width: 97% !important;
  height: 30px !important;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25) !important;
  border-radius: 5px;
  padding-inline: 1%;
  padding-bottom: 1%;
  font-size: 12px !important;
  display: block !important;
}
.guidtype_feild .mat-form-field-appearance-legacy .mat-form-field-infix {
  margin-top: 0 !important;
  padding-bottom: 0 !important;
  padding-top: 3% !important;
  font-size: 12px !important;
}

::ng-deep.modalConfig .modal-dialog {
  max-width: 36% !important;
  max-height: 60% !important;
  height: 60% !important;
  margin: auto !important;
  padding: 0 !important;
  top: 24% !important;
}

::ng-deep.modalConfigJSON .modal-dialog {
  max-width: 70% !important;
  max-height: 60% !important;
  height: 60% !important;
  margin: auto !important;
  padding: 0 !important;
  top: 7% !important;
}

.customguid_feild {
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25) !important;
  float: left;
  height: 30px !important;
  font-size: 12px !important;
}

::ng-deep.config_dropdown .mat-form-field-appearance-legacy .mat-form-field-infix {
  padding-top: 0 !important;
}

::ng-deep.modal-backdrop.show {
  z-index: 1050 !important;
}`, "",{"version":3,"sources":["webpack://./src/app/config/config.component.scss","webpack://./src/variables.scss"],"names":[],"mappings":"AACA;EACI,WAAA;EACA,WAAA;AAAJ;;AAGE;EACE,qBAAA;EAEA,uBCLS;EDMT,oDAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,0BCbO;EDcP,yBAAA;AADJ;AAEI;EACE,wBAAA;EACA,4BAAA;EACA,0BAAA;EACA,0BCnBK;ADmBX;;AAGE;EACE,yBAAA;EACA,0BAAA;EACA,sBAAA;EACA,uBAAA;EACA,qBAAA;EACA,mBAAA;AAAJ;;AAEE;EACE,yBAAA;EACA,0BAAA;EACA,sBAAA;EACA,uBAAA;EACA,qBAAA;EACA,kBAAA;AACJ;;AACE;EACE,oDAAA;EACA,WAAA;EAGE,uBCxCO;EDyCP,0BC5CK;AD4CX;;AAGE;EACE,yBAAA;AAAJ;;AAEE;EACF,wBAAA;AACA","sourcesContent":["@import \"../../variables.scss\";\r\n.agent_feild{\r\n    width: 100%;\r\n    float: left;\r\n    // margin-left: 1%;\r\n  }\r\n  .guidtype_feild{\r\n    width: 97% !important;\r\n    // margin-left: 8%;\r\n    height: $inputHeight;\r\n    box-shadow: 0 2px 5px rgb(0 0 0 / 25%) !important;\r\n    border-radius: 5px;\r\n    padding-inline: 1%;\r\n    padding-bottom: 1%;\r\n    font-size:$fontsize;\r\n    display: block !important;\r\n    .mat-form-field-appearance-legacy .mat-form-field-infix{\r\n      margin-top: 0 !important;\r\n      padding-bottom: 0 !important;\r\n      padding-top: 3%!important ;\r\n      font-size:$fontsize;\r\n    }\r\n  }\r\n  ::ng-deep.modalConfig .modal-dialog {\r\n    max-width: 36% !important;\r\n    max-height: 60% !important;\r\n    height: 60% !important;\r\n    margin: auto !important;\r\n    padding: 0 !important;\r\n    top: 24%!important;\r\n  }\r\n  ::ng-deep.modalConfigJSON .modal-dialog {\r\n    max-width:70% !important;\r\n    max-height: 60% !important;\r\n    height: 60% !important;\r\n    margin: auto !important;\r\n    padding: 0 !important;\r\n    top: 7%!important;\r\n  }\r\n  .customguid_feild{\r\n    box-shadow: 0 2px 5px rgb(0 0 0 / 25%) !important;\r\n    float: left;\r\n      // width: 80%;\r\n      // margin-left: 6%;\r\n      height: $inputHeight;\r\n      font-size:$fontsize;\r\n  }\r\n\r\n  ::ng-deep.config_dropdown  .mat-form-field-appearance-legacy .mat-form-field-infix{\r\n    padding-top: 0 !important;\r\n  }\r\n  ::ng-deep.modal-backdrop.show {\r\nz-index: 1050 !important;\r\n  }\r\n","$btn-color: #17a0b4 !important;\r\n$fontsize: 12px !important;\r\n$btntextcolor: white !important;\r\n$btnHeight: 28px !important;\r\n$inputHeight:30px !important;\r\n$inputfontsize:11px !important;\r\n$primary:#004bff;\r\n// $modalHeaderTitleFont: ;\r\n@mixin modalheaderTtext {\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
